import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search';
import NorthWestIcon from '@mui/icons-material/NorthWest';
import { textRapForNameSearch } from '../../utils/textRapUtils'

import { createSearchedKeywordAction } from '../../redux/actions/searchAction'
import fallbackProductImage from '../../images/not_found_product.png'

import axios from 'axios';

const safeText = (value, fallback = '') => {
    if (value === null || value === undefined) return fallback;
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    return fallback;
}

function SearchItems({ initialValue = "" }) {
    const history = useHistory()
    const dispatch = useDispatch()

    const [shoesName, setShoesName] = useState(initialValue)
    const [autoCompleteSearchProduct, setautoCompleteSearchProduct] = useState([])
    const [isSearching, setIsSearching] = useState(false)
    const [isSuggestionOpen, setIsSuggestionOpen] = useState(false)

    const popularSearches = ['Nike', 'Jordan', 'Converse', 'Sports', 'Loafer'];

    useEffect(() => {
        setShoesName(initialValue)
    }, [initialValue])

    useEffect(() => {
        const cleanedSearch = shoesName.trim();

        if (!cleanedSearch) {
            setautoCompleteSearchProduct([])
            setIsSearching(false)
            setIsSuggestionOpen(false)
            return undefined
        }

        const searchTimer = setTimeout(() => {
            (async () => {
                try {
                    setIsSearching(true)
                    const url = `/api/search/find/shoesName=/name`
                    const { data } = await axios.get(url, {
                        params: {
                            shoesName: cleanedSearch
                        },
                    })
                    setautoCompleteSearchProduct(Array.isArray(data.msg) ? data.msg.slice(0, 6) : [])
                    setIsSuggestionOpen(true)
                } catch (error) {
                    setautoCompleteSearchProduct([])
                    setIsSuggestionOpen(true)
                } finally {
                    setIsSearching(false)
                }
            })()
        }, 250)

        return () => clearTimeout(searchTimer)
    }, [shoesName])

    const selectHandler = (text) => {
        const cleanedSearch = String(text || '').trim()
        if (!cleanedSearch) return
        setShoesName(cleanedSearch)
        setIsSuggestionOpen(false)
        history.push(`/searched/${encodeURIComponent(cleanedSearch)}`)
        dispatch(createSearchedKeywordAction(cleanedSearch))
    }

    const searchedDataHandler = (e) => {
        setShoesName(e.target.value)
        setIsSuggestionOpen(true)
    }


    const showSearchHandler = (e) => {
        e.preventDefault()
        const cleanedSearch = shoesName.trim()
        if (!cleanedSearch) return
        setIsSuggestionOpen(false)
        history.push(`/searched/${encodeURIComponent(cleanedSearch)}`)
        dispatch(createSearchedKeywordAction(cleanedSearch))
    }

    const quickSearchHandler = (keyword) => {
        setShoesName(keyword)
        setIsSuggestionOpen(false)
        history.push(`/searched/${encodeURIComponent(keyword)}`)
        dispatch(createSearchedKeywordAction(keyword))
    }




    return (
        <Fragment>
            <form onSubmit={showSearchHandler} className="search-experience-form">
                <div className='autosearch-form-main-div'>
                    <SearchIcon className="search-field-icon" />
                    <input className='search-input-form' type="text" placeholder='Search Nike, Jordan, Sports, Loafers...' value={shoesName} onChange={searchedDataHandler} required />
                    <button className='search-btn-icons-style' type="submit">Search</button>
                </div>
                {isSuggestionOpen && shoesName.trim().length !== 0 ? (
                    <div className='searched-data-show-container'>
                        {isSearching && <div className="searched-item-status">Finding matches...</div>}
                        {!isSearching && autoCompleteSearchProduct.length === 0 && (
                            <div className="searched-item-status">Press Search to see all matching products.</div>
                        )}
                        {!isSearching && autoCompleteSearchProduct.map((hey, index) => {
                            const productName = safeText(hey?.name, 'Product');
                            const productImage = safeText(hey?.mainImage?.[0]?.imageurl);

                            return (
                            <div className="searched-item-div" key={safeText(hey?._id, index)}>
                                {productImage && (
                                    <img
                                        src={productImage}
                                        alt={productName}
                                        onError={(event) => {
                                            event.currentTarget.onerror = null;
                                            event.currentTarget.src = fallbackProductImage;
                                        }}
                                    />
                                )}
                                <button type="button" onClick={() => selectHandler(productName)}>
                                    <span>{textRapForNameSearch(productName)}</span>
                                    <NorthWestIcon />
                                </button>
                            </div>
                            )
                        })}
                    </div>
                ) : null}

                <div className="search-suggestion-row" aria-label="Popular searches">
                    {popularSearches.map((keyword) => (
                        <button type="button" key={keyword} onClick={() => quickSearchHandler(keyword)}>
                            {keyword}
                        </button>
                    ))}
                </div>
                
            </form>
        </Fragment>

    )
}

export default SearchItems
